import { NgModule } from "@angular/core";
import { RouterModule, PreloadAllModules } from "@angular/router";

// Components
import { MainComponent } from "./main/main.component";
import { LoginComponent } from "./login/login.component";

// Activates
import {
	ActivateMain,
	ActivateLogin,
	ActivateApplicationsHome
} from "./activates";
// Resolvers
import { LoginResolver } from "./resolvers";
// Preloads
import { AppPreLoadingStrategy } from "./app.preloadstrategy";

@NgModule({
	imports: [
		RouterModule.forRoot(
			[
				{
					path: "main",
					component: MainComponent,
					canActivate: [ActivateMain]
				},
				{
					path: "login",
					component: LoginComponent,
					canActivate: [ActivateLogin],
					resolve: { contacts: LoginResolver }
				},
				{
					path: "applications",
					loadChildren:
						"app/modules/applications/applications.module#ApplicationsModule",
					canActivate: [ActivateApplicationsHome]
				},

				{
					path: "levels/level3",
					loadChildren:
						"app/modules/levels/level-3/level-3.module#Level3Module"
				},
				{
					path: "levels/level2",
					loadChildren:
						"app/modules/levels/level-2/level-2.module#Level2Module"
				},
				{
					path: "levels/level1",
					loadChildren:
						"app/modules/levels/level-1/level-1.module#Level1Module"
				},
				// {
				// 	path: 'approval',
				// 	loadChildren: 'app/modules/approvalprocess/approvalprocess.module#ApprovalProcessModule'

				// },

				{
					path: "detail",
					loadChildren:
						"app/modules/detail/detail.module#DetailModule"
				},

				{
					path: "",
					redirectTo: "main",
					pathMatch: "full"
				},
				{
					path: "**",
					redirectTo: "applications",
					pathMatch: "full"
				}
			],
			{ enableTracing: false, preloadingStrategy: AppPreLoadingStrategy }
		)
	],
	providers: [AppPreLoadingStrategy],
	exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/app.routing.module.ts